import { render, staticRenderFns } from "./v-input-tag.vue?vue&type=template&id=c992c07a&"
import script from "./v-input-tag.vue?vue&type=script&lang=js&"
export * from "./v-input-tag.vue?vue&type=script&lang=js&"
import style0 from "./v-input-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports